import ToolBar from '@/components/ToolBar';

export const DashBoard = () => {
  return (
    <>
      <ToolBar title="Dashboard" />
    </>
  );
};

export default DashBoard;
